
 <div id="autocomplete-wrapper"  >
    <div id="autocomplete-input">
       <input #autoCompleteInput  name="question" id="inputField" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
   
      </div>
  </div>  
